import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import rankingQuery from "@packagesModules/rankingQuery/index.js";

const routerView = (resolve) => require(["@/components/common/routerView.vue"], resolve); //主页
const layout = (resolve) => require(["@/views/layout/layout.vue"], resolve); //布局
// let index = (resolve) => require(["@/views/index/index.vue"], resolve); //主页
import index from "@/views/index/index.vue"; //主页

const offers = (resolve) => require(["@/views/offers/offers.vue"], resolve); //商品
const offersOrigin = (resolve) => require(["@/views/offers/offersOrigin.vue"], resolve); //商品旧版
const external = (resolve) => require(["@/views/offers/external.vue"], resolve);

const customer = (resolve) => require(["@/views/customer/customer.vue"], resolve); //顾客
const arrears = (resolve) => require(["@/views/customer/arrearsHandle/arrears.vue"], resolve); // 收记 欠款
const cusDetails = (resolve) => require(["@/views/customer/cusDetails/cusDetails.vue"], resolve); // 客户详情
const collectMoney = (resolve) => require(["@/views/collectMoney/collectMoney.js"], resolve); //收银
const processingCollectMoney = (resolve) =>
  require(["@/views/processingCollectMoney/collectMoney.js"], resolve); //收银

const carList = (resolve) => require(["@/views/collectMoney/carList.js"], resolve); //购物车
const processingCarList = (resolve) =>
  require(["@/views/processingCollectMoney/carList.js"], resolve); //购物车

const payIndex = (resolve) => require(["@/views/collectMoney/payIndex.vue"], resolve); //购物车
const paySuccess = (resolve) => require(["@/views/collectMoney/paySuccess.vue"], resolve); //支付成功
const payQrcode = (resolve) => require(["@/views/collectMoney/qrcode.js"], resolve); //支付成功
const processingPayQrcode = (resolve) =>
  require(["@/views/processingCollectMoney/qrcode.js"], resolve);
const order = (resolve) => require(["@/views/order/order.vue"], resolve); //订单
const orderDetail = (resolve) => require(["@/views/order/detail.vue"], resolve); //订单详情

const staff = (resolve) => require(["@/views/staff/staff.vue"], resolve); //员工管理
const staffV2 = (resolve) => require(["@/views/staffV2/staff.vue"], resolve); //员工管理v2
const authManage = (resolve) => require(["@/views/authManage/index.vue"], resolve); //授权管理

const account = (resolve) => require(["@/views/account/account.vue"], resolve); //账户
const member = (resolve) => require(["@/views/member/member.vue"], resolve); //个人中心 弃用
const personalCenter = (resolve) => require(["@/views/member/personalCenter.vue"], resolve); //新的个人中心
const chargeCenter = (resolve) => require(["@/views/chargeCenter/chargeCenter.vue"], resolve); //充值中心
const authorizeList = (resolve) => require(["@/views/member/authorizeList.vue"], resolve);
const roleList = (resolve) => require(["@/views/member/roleList.vue"], resolve);

const downloadOrigin = (resolve) => require(["@/views/download/downloadOrigin.vue"], resolve); //用户下载页面
const download = (resolve) => require(["@/views/download/download.vue"], resolve); //用户下载页面
const useHelp = (resolve) => require(["@/views/common/useHelp.vue"], resolve); //使用帮助
const ExpiredHelp = (resolve) => require(["@/views/common/ExpiredHelp.vue"], resolve); //1元過期帮助

const userLogin = (resolve) => require(["@/views/login/login.vue"], resolve); //用户登录界面
const loginAuth = (resolve) => require(["@/views/common/loginAuth.vue"], resolve);

const originalPush = VueRouter.prototype.push;
const markProduct = (resolve) => require(["@/views/markProduct/index.vue"], resolve);
const markProduct1688hjx = (resolve) =>
  require(["@/views/markProduct/markProduct1688hjx.js"], resolve);

const markProductWaodz = (resolve) => require(["@/views/markProduct/markProductWaodz.js"], resolve);
const markProductDaYanxuan = (resolve) =>
  require(["@/views/markProduct/markProductDaYanxuan.js"], resolve);
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routerObj = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  name: "main",
  routes: [
    {
      path: "/",
      name: "index",
      component: layout,
      redirect: "/index",
      children: [
        {
          path: "/index",
          component: index,
        },
        {
          path: "/offers",
          component: routerView,
          children: [
            {
              path: "index",
              component: offers,
            },
            {
              path: "external/:src",
              component: external,
            },
            {
              path: "origin",
              component: offersOrigin,
            },
            {
              path: "spczgk",
              component: () => import("../views/npmFunction/productGrowthSurvey.vue"),
              meta: { qoePosition: "商品成长概况", qoeName: "productGrowthSurvey" },
            },
            {
              path: "spczgl",
              component: () => import("../views/npmFunction/productGrowthManage.vue"),
              meta: { qoePosition: "商品成长管理", qoeName: "productGrowthManage" },
            },
          ],
        },
        {
          path: "/customer",
          component: routerView,
          children: [
            {
              path: "/",
              component: customer,
            },
            {
              path: "/customer/arrearsHandle",
              component: arrears,
            },
            {
              path: "/customer/cusDetails",
              component: cusDetails,
            },
          ],
        },
        {
          path: "/chargeCenter",
          component: chargeCenter,
        },
        {
          path: "/account",
          component: account,
        },
        {
          path: "/staff",
          component: staff,
        },
        {
          path: "/staffV2",
          component: staffV2,
        },
        {
          path: "/authManage",
          component: authManage,
        },

        {
          path: "/download",
          component: download,
        },
        {
          path: "/downloadOrigin",
          component: downloadOrigin,
        },
        {
          path: "/collectMoney",
          component: routerView,
          children: [
            {
              path: "/",
              component: collectMoney,
            },
            {
              path: "carList",
              component: carList,
            },
            {
              path: "payIndex",
              component: payIndex,
            },
            {
              path: "paySuccess",
              component: paySuccess,
            },
            {
              path: "payQrcode",
              component: payQrcode,
            },
          ],
        },
        {
          path: "/processingCollectMoney",
          component: routerView,
          children: [
            {
              path: "/",
              component: processingCollectMoney,
            },
            {
              path: "carList",
              component: processingCarList,
            },
            {
              path: "payIndex",
              component: payIndex,
            },
            {
              path: "paySuccess",
              component: paySuccess,
            },
            {
              path: "payQrcode",
              component: processingPayQrcode,
            },
          ],
        },
        {
          path: "/member",
          component: routerView,
          children: [
            {
              path: "/",
              component: member,
            },
            {
              path: "authorizeList",
              component: authorizeList,
            },
            {
              path: "roleList",
              component: roleList,
            },
          ],
        },
        {
          path: "/order",
          component: routerView,
          children: [
            {
              path: "/",
              component: order,
              // meta: {
              //     keepAlive: true // 不需要缓存
              //   }
            },
            {
              path: "detail",
              component: orderDetail,
            },
          ],
        },
        {
          path: "/spbj",
          component: markProduct,
          children: [
            {
              path: "markProduct1688hjx",
              name: "markProduct1688hjx",
              component: markProduct1688hjx,
              // meta: {
              //     keepAlive: true // 不需要缓存
              //   }
            },
            {
              path: "markProductWaodz",
              name: "markProductWaodz",
              component: markProductWaodz,
            },

            {
              path: "markProductDaYanxuan",
              name: "markProductDaYanxuan",
              component: markProductDaYanxuan,
            },

            {
              path: "/",
              redirect: "markProduct1688hjx",
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "userlogin",
      component: routerView,
      redirect: "/userLogin",
      children: [
        {
          path: "/userLogin",
          component: userLogin,
        },
      ],
    },
    {
      path: "/useHelp",
      name: "useHelp",
      component: useHelp,
    },
    {
      path: "/ExpiredHelp",
      name: "ExpiredHelp",
      component: ExpiredHelp,
    },
    {
      path: "/loginAuth",
      name: "loginAuth",
      component: loginAuth,
    },
    {
      path: "/yhyl",
      name: "yhyl",
      component: layout,
      children: [],
    },
    {
      path: "/pmcx",
      name: "pmcx",
      component: layout,
      children: [
        {
          path: "/",
          redirect: "cppmcx",
        },
      ],
    },
  ],
});

const loaders = {
  "yhyl/zdcf": async () => {
    let autoRepost = await import("@packages/modules/autoRepost/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("yhyl", {
      path: "zdcf", //自动重发
      component: () => import("../views/npmFunction/autoRepost.vue"),
      children: autoRepost.childRoutes,
    });
  },
  "yhyl/zdpj": async () => {
    let autoRepost = await import("@packages/modules/autoComments/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("yhyl", {
      path: "zdpj",
      component: () => import("../views/npmFunction/autoComments.vue"),
      children: autoRepost.childRoutes,
    });
  },

  "yhyl/yjbdt": async () => {
    let autoRepost = await import("@packages/modules/oneWhiteImg/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("yhyl", {
      path: "yjbdt",
      name: "yjbdt",
      component: () => import("../views/npmFunction/oneWhiteImg.vue"),
      children: autoRepost.childRoutes,
    });
  },

  "yhyl/ztsp": async () => {
    let autoRepost = await import("@packages/modules/mainVideo/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("yhyl", {
      path: "ztsp",
      name: "ztsp",
      component: () => import("../views/npmFunction/mainVideo.vue"),
      children: autoRepost.childRoutes,
    });
  },
  "yhyl/spjjsp": async () => {
    let autoRepost = await import("@packages/modules/explainVideo/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("yhyl", {
      path: "spjjsp",
      name: "spjjsp",
      component: () => import("../views/npmFunction/explainVideo.vue"),
      children: autoRepost.childRoutes,
    });
  },
  "yhyl/hbzz": async () => {
    let autoRepost = await import("@packages/modules/posterTemplate/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("yhyl", {
      path: "hbzz",
      name: "hbzz",

      component: () => import("../views/npmFunction/posterTemplate.vue"),
      children: autoRepost.childRoutes,
    });
  },
  "pmcx/cppmcx": async () => {
    let autoRepost = await import("@packages/modules/rankingQuery/index.js");
    autoRepost = autoRepost.default;
    routerObj.addRoute("pmcx", {
      path: "cppmcx",

      component: () => import("../views/npmFunction/rankingQuery.vue"),
      children: autoRepost.childRoutes,
      meta: {
        // src: `${DOMAIN}/so`,
        charge: true,
      },
    });
  },
};

function getLoader(path) {
  const target = Object.keys(loaders).find((key) => {
    return path.startsWith(key);
  });
  if (target) {
    return {
      key: target,
      loader: loaders[target],
    };
  }

  return { loader: false };
}

const nameMap = {};

routerObj.beforeEach(async (to, from, next) => {
  let targetPath = to.path.slice(1);

  if (to.name && to.path === "/") {
    targetPath = nameMap[to.name] || "";
  } else {
    targetPath = to.path.slice(1);
  }

  const { key, loader } = getLoader(targetPath);
  if (loader) {
    await loader();
    loaders[key] = false;

    next(to);

    return to.fullPath;
  }

  next();
});
export default routerObj;
